import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCheckMark(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M27.7677 9.99994L14.8838 22.8838C14.3957 23.372 13.6042 23.372 13.1161 22.8838L4.23218 13.9999L5.99994 12.2322L13.9999 20.2322L25.9999 8.23218L27.7677 9.99994Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCheckMark);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
